import { render, staticRenderFns } from "./detailKnowledge.vue?vue&type=template&id=4d381230&scoped=true&"
import script from "./detailKnowledge.vue?vue&type=script&lang=js&"
export * from "./detailKnowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d381230",
  null
  
)

export default component.exports